//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// header imports
import { ITipProps } from "./SuggestionCardHeader.d";
import { tipStyles as s } from "./SuggestionCardHeader.styles";
// other components
import { A, H2 } from "@ui";
import { CardTopLine } from "@components/card-top-line";
import { track } from "@util/analytics.util";

//////////////////
// COMPONENT
//////////////////
export const SuggestionCardHeaderTip = ({
  label,
  moreInfoLink,
  moreInfoTracking,
  occurredMillis,
  removeCard,
  text,
  tipConfig,
}: ITipProps) => {
  const bodyStyle = {
    ...s.tipBody,
    background: tipConfig.bodyBackground,
    color: tipConfig.colorText,
  };

  const helpLink = tipConfig.moreInfoLink || moreInfoLink || undefined;

  function onLearnMore() {
    const helpTracking = tipConfig.moreInfoTracking || moreInfoTracking || undefined;
    if (helpTracking) {
      track(helpTracking);
    }
  }

  // TODO: https://app.asana.com/0/728517899435626/938907266991881
  const illustrationHeight =
    tipConfig.illustrationHeight === 144 ? undefined : tipConfig.illustrationHeight;

  const illustrationWidth = illustrationHeight ? undefined : "100%";

  const bannerStyle = {
    ...s.tipBanner,
    background: illustrationWidth ? undefined : tipConfig.illustrationBackground,
  };

  return (
    <div style={s.tipContainer}>
      <div style={s.topLine}>
        <CardTopLine timeStamp={occurredMillis} clear={removeCard} label={label} />
      </div>
      <div style={bannerStyle}>
        <img src={tipConfig.illustration} height={illustrationHeight} width={illustrationWidth} />
      </div>
      <div style={bodyStyle}>
        <H2 style={{ ...s.tipHeader, color: tipConfig.colorHeader || s.headerColor }}>
          {text.title}
        </H2>
        <div style={s.tipSubHeading}>
          {text.subHeading}
          {!!helpLink ? (
            <span>
              &nbsp;
              <A href={helpLink} target="_blank" light onClick={onLearnMore}>
                Learn more
              </A>
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
